const Validation = { isNumber};
export default Validation;
const regExpStringIsValidInt = /^-?\d+$/;
const regExpStringIsValidFloat = /^-?\d+\.\d+$/;
function isNumber(value) {
    if (value === undefined || value === null) return false;
    if (typeof (value) === 'string') {
        if (!numberStringIsValid(value)) return false;
    }
    const number = parseFloat(value);
    if (isNaN(number)) return false;
    return true
}
function numberStringIsValid(str) {
    if (str.match(regExpStringIsValidInt)) return true;
    if (str.match(regExpStringIsValidFloat)) return true;
    return false;
}
